<h1 class="main-title">Políticas de Privacidade da Plataforma MZIC</h1>

<h2 class="section-heading">1. Quem somos e papéis de tratamento</h2>
<p class="text-content">
  <strong>Controladora:</strong>
  MZIC Brasil S.A. (Brasil) – CNPJ: 60.978.531/0001‑85.
</p>
<p class="text-content">
  Operadores/Fornecedores (exemplos): serviços de computação em nuvem,
  verificação de identidade (KYC), meios de pagamento, analytics, antifraude,
  provedores de e‑mail e mensageria, entre outros. A lista atualizada pode ser
  solicitada por meio do canal abaixo.
</p>
<p class="text-content">Canal de informações: legal&#64;mzic.io.</p>

<h2 class="section-heading">2. Âmbito de aplicação</h2>
<p class="text-content">
  Esta Política aplica‑se a usuários da plataforma (titulares de direitos,
  compradores/investidores, representantes e visitantes), bem como a leads que
  interajam com nossos canais digitais. Políticas internas específicas podem
  complementar este documento em relações trabalhistas e institucionais.
</p>

<h2 class="section-heading">3. Dados que coletamos</h2>

<h3 class="subsection-heading">3.1 Dados de conta e uso</h3>
<ul class="content-list">
  <li>
    Identificação de conta (coletada conforme o tipo de usuário; lista
    exemplificativa — a MZIC poderá solicitar dados adicionais quando necessário
    às finalidades desta Política e/ou para cumprimento de obrigações
    legais/regulatórias):
    <ul class="sub-list">
      <li>
        Investidor (PF): nome completo, e‑mail, telefone, CPF, data de
        nascimento, endereço de residência, qualificação do investidor, renda
        mensal aproximada e cidadania.
      </li>
      <li>
        Titular de direitos – PF (artista/intérprete/produtor): nome completo,
        e‑mail, telefone, CPF, data de nascimento, endereço de residência e nome
        artístico (quando aplicável).
      </li>
      <li>
        Gravadora/Produtora – PJ: razão social/nome fantasia, CNPJ, e‑mail e
        telefone de contato, endereço da sede e representante legal (nome e
        CPF).
      </li>
      <li>
        Editora – PJ: razão social/nome fantasia, CNPJ, e‑mail e telefone de
        contato, endereço da sede, representante legal (nome e CPF) e, quando
        existentes, código IPI, código CAE e código ECAD.
      </li>
      <li>Em todos os casos: credenciais e logs de acesso.</li>
    </ul>
  </li>
  <li>
    Dados de uso da plataforma: ações executadas, páginas/recursos acessados,
    endereço IP, identificadores de dispositivos, configurações e preferências,
    idioma, datas e horários de acesso.
  </li>
  <li>
    Comunicações com a MZIC (suporte, tickets, chat, e‑mails) e conteúdo que
    você publica ou envia para a plataforma.
  </li>
</ul>

<h3 class="subsection-heading">3.2 Dados transacionais e financeiros</h3>
<ul class="content-list">
  <li>
    Histórico de operações no marketplace, ordens, liquidações, repasses de
    royalties, comprovantes, notas fiscais.
  </li>
  <li>
    Métodos de pagamento e dados de faturamento limitados ao necessário para
    processar transações (tokens de pagamento, identificadores de PSPs, status
    de pagamento).
  </li>
</ul>

<h3 class="subsection-heading">
  3.3 Verificação de identidade (KYC/AML) – inclui dados sensíveis
</h3>
<ul class="content-list">
  <li>
    Documento oficial (frente/verso) e selfie para validação biométrica; data de
    nascimento, CPF (ou equivalente), endereço completo e demais elementos
    exigidos por lei/regulação e prevenção à fraude.
  </li>
  <li>
    Esses dados podem ser coletados/validados por fornecedores especializados
    (ex.: serviços KYC), atuando como operadores em nome da MZIC.
  </li>
</ul>

<h3 class="subsection-heading">3.4 Cookies e tecnologias semelhantes</h3>
<ul class="content-list">
  <li>
    Cookies de funcionalidade, desempenho/analytics e publicidade/medição;
    pixels e identificadores de SDK em apps móveis. Ver Seção 7 (Cookies) e
    Anexo B (Categorias de Cookies).
  </li>
</ul>

<h3 class="subsection-heading">3.5 Dados de terceiros e públicos</h3>
<ul class="content-list">
  <li>
    Informações disponibilizadas por parceiros (ex.: detentores de direitos,
    distribuidoras/agregadoras, PSPs, marketplaces parceiros) e dados
    publicamente disponíveis necessários para verificar titularidade/uso de
    obras e fonogramas.
  </li>
  <li>
    Analytics e sessão (PostHog). Coletamos eventos e métricas de interação por
    meio do PostHog (prestador de serviços de analytics), que atua como operador
    em nome da MZIC. Dependendo da configuração, podem ser tratados: páginas
    visitadas, cliques, rolagem, tempo de sessão, identificadores de
    dispositivo/navegador, endereço IP (com truncamento/anonimização quando
    aplicável), user‑agent e gravações de sessão/mapas de calor (se
    habilitados). Esses dados são utilizados para medição de uso, diagnóstico e
    melhoria de produto (vide Seção 7 e Anexo B) e estão sujeitos também aos
    termos e Política de Privacidade do PostHog. O PostHog poderá processar
    dados no Brasil e/ou no exterior, conforme a localidade de processamento
    contratada, observadas as salvaguardas da Seção 9. Quando exigido, a coleta
    depende de consentimento, e você pode gerir suas preferências no Gerenciador
    de Cookies.
  </li>
</ul>

<h2 class="section-heading">4. Bases legais</h2>
<p class="text-content">
  Tratamos dados com fundamento, conforme o caso, em: (a) cumprimento de
  obrigação legal ou regulatória (ex.: KYC/AML, prevenção à fraude, exigências
  fiscais), (b) execução de contrato ou procedimentos preliminares, (c) legítimo
  interesse (ex.: segurança, melhoria de serviços, prevenção a abuso), (d)
  consentimento (ex.: certos cookies/marketing), e (e) exercício regular de
  direitos (judiciais ou administrativos). Dados sensíveis (ex.:
  biometria/selfie para verificação) são tratados quando necessário para
  cumprimento de obrigação legal ou regulatória e prevenção à fraude/segurança,
  com salvaguardas adequadas.
</p>

<h2 class="section-heading">5. Finalidades e atividades de tratamento</h2>
<ul class="content-list">
  <li>
    Prover e operar a plataforma: criar/gerenciar contas, personalizar
    experiência, processar transações, exibir portfólios, distribuir royalties,
    emitir documentos fiscais/comprovantes.
  </li>
  <li>
    KYC/AML e segurança: verificar identidade, detectar e prevenir fraudes,
    bloquear atividades abusivas, manter integridade de sistemas, gerir riscos e
    conformidade.
  </li>
  <li>
    Execução e gestão contratual: relacionamento com detentores de direitos,
    rateios/splits, prestação de contas, reconciliação e auditorias.
  </li>
  <li>
    Atendimento e comunicações: suporte, notificações transacionais e
    operacionais.
  </li>
  <li>
    Melhoria de produto e analytics: métricas de uso, testes, estatísticas e
    pesquisas (com minimização e, quando aplicável,
    anonimização/pseudonimização).
  </li>
  <li>
    Marketing e publicidade: envio de comunicações e uso de
    cookies/identificadores mediante consentimento e com opção de
    cancelamento/opt‑out.
  </li>
  <li>
    Cumprimento legal/regulatório e exercício de direitos: registros, livros e
    guarda de evidências.
  </li>
</ul>

<h2 class="section-heading">6. Perfil público e dados on‑chain</h2>
<p class="text-content">
  Determinados elementos do seu perfil (ex.: nome artístico, foto, handle
  público e endereço de conta digital/carteira inteligente associada à
  plataforma) e o inventário de ativos podem ser visíveis ao público.
</p>
<ul class="content-list">
  <li>
    Endereços on‑chain e dados de blockchain possuem natureza de registro
    permanente e público. Quando você solicitar exclusão, não é possível deletar
    dados imutáveis gravados em redes públicas; adotamos, contudo, medidas de
    minimização e desvinculação, como remoção de vínculos internos entre sua
    conta e endereços públicos, quando permitido.
  </li>
  <li>
    Metadados e identificadores (ex.: ISRC/ISWC) necessários à identificação e
    prestação de contas podem constar de bases públicas/privadas de terceiros
    (ex.: sociedades de gestão, agregadoras) e seguir suas regras próprias.
  </li>
</ul>

<h2 class="section-heading">7. Cookies e tecnologias semelhantes</h2>
<p class="text-content">
  Usamos cookies para autenticação, segurança, preferências,
  performance/analytics e publicidade/medição.
</p>
<ul class="content-list">
  <li>
    Implementamos banner/console de preferências para coleta de consentimento
    onde exigido.
  </li>
  <li>
    Você pode gerenciar cookies nas configurações do navegador e por meio do
    nosso Gerenciador de Cookies; o bloqueio pode afetar funcionalidades.
  </li>
</ul>
<p class="text-content">Categorias (resumo):</p>
<ul class="content-list">
  <li>Estritamente necessários/funcionais (ex.: login, sessão).</li>
  <li>
    Analíticos (ex.: métricas de uso; agregados, com IP truncado quando viável).
  </li>
  <li>
    Publicidade/medição (ex.: personalização/limitação de frequência; sempre
    sujeitos a consentimento e opt‑out).
  </li>
</ul>
<p class="text-content">Detalhes no Anexo B.</p>

<h2 class="section-heading">8. Compartilhamento de dados</h2>
<p class="text-content">
  Compartilhamos dados pessoais apenas conforme necessário com:
</p>
<ul class="content-list">
  <li>
    Prestadores/Operadores: computação em nuvem, KYC/AML, pagamentos,
    antifraude, analytics, customer support e mensageria.
  </li>
  <li>
    Parceiros de negócios: detentores de direitos, agregadoras/distribuidoras,
    marketplaces e instituições parceiras, para viabilizar operações e repasses.
  </li>
  <li>
    Autoridades e reguladores: mediante obrigação legal/regulatória ou ordem de
    autoridade competente.
  </li>
  <li>
    Operações societárias: em caso de fusão, aquisição, reorganização,
    observadas as salvaguardas de proteção de dados.
  </li>
</ul>
<p class="text-content">
  Celebramos contratos com operadores prevendo confidencialidade, finalidades,
  segurança, instruções documentadas, suboperadores e auditoria, conforme a
  LGPD.
</p>

<h2 class="section-heading">9. Transferências internacionais</h2>
<p class="text-content">
  Os dados podem ser tratados e armazenados no Brasil e nos Estados Unidos,
  inclusive em provedores de nuvem (ex.: AWS). Aplicamos cláusulas contratuais e
  garantias adequadas, além de avaliações de transferência, para assegurar nível
  de proteção compatível com a LGPD. Quando cabível, adotaremos mecanismos
  adicionais (criptografia, pseudonimização, controles de acesso, data residency
  por serviço).
</p>

<h2 class="section-heading">10. Segurança da informação</h2>
<p class="text-content">
  Adotamos medidas técnicas e administrativas proporcionais ao risco, incluindo
  criptografia em repouso e trânsito quando aplicável, hardening de
  infraestrutura, controles de acesso, logging e monitoramento, segregação de
  ambientes, backup e disaster recovery. Incidentes de segurança que possam
  acarretar risco ou dano relevante serão avaliados e, quando exigido,
  comunicados à autoridade competente e aos titulares afetados, com os devidos
  registros.
</p>

<h2 class="section-heading">11. Retenção e eliminação de dados</h2>
<p class="text-content">
  Mantemos dados somente pelo tempo necessário ao cumprimento das finalidades e
  pelos prazos mínimos legais/regulatórios aplicáveis (ex.: prevenção à lavagem
  de dinheiro, contabilidade/fiscal, defesa em processos). Ao término,
  realizamos a eliminação ou anonimização. Veja o Anexo A para prazos de
  referência por categoria.
</p>

<h2 class="section-heading">12. Direitos dos titulares (LGPD)</h2>
<p class="text-content">Você pode exercer, nos termos da LGPD:</p>
<ul class="content-list">
  <li>Confirmação de tratamento e acesso;</li>
  <li>Correção de dados incompletos, inexatos ou desatualizados;</li>
  <li>
    Anonimização, bloqueio ou eliminação de dados desnecessários/excessivos;
  </li>
  <li>Portabilidade, quando aplicável;</li>
  <li>
    Informação sobre compartilhamento e sobre a possibilidade de não consentir;
  </li>
  <li>Revogação do consentimento;</li>
  <li>Revisão de decisões automatizadas que afetem seus interesses;</li>
  <li>Oposição a tratamento fundado em legítimo interesse, quando cabível.</li>
</ul>
<p class="text-content">
  Para exercer seus direitos, utilize o canal de contato indicado na Seção 1.
</p>

<h2 class="section-heading">13. Crianças e adolescentes</h2>
<p class="text-content">
  A plataforma não é direcionada a menores de 18 anos. Caso identifiquemos conta
  de menor sem a devida base legal, adotaremos as medidas cabíveis para exclusão
  ou regularização.
</p>

<h2 class="section-heading">14. Comunicações de marketing</h2>
<p class="text-content">
  Enviamos comunicações de marketing com base em consentimento ou legítimo
  interesse, quando apropriado, sempre com opção clara de opt‑out (cancelamento)
  nos próprios e‑mails/mensagens ou por meio das configurações de conta.
</p>

<h2 class="section-heading">15. Alterações desta Política</h2>
<p class="text-content">
  Podemos atualizar esta Política para refletir mudanças legais, regulatórias,
  tecnológicas ou de negócio. Publicaremos a nova versão com data de vigência e,
  quando mudanças materiais ocorrerem, forneceremos aviso adicional por
  e‑mail/plataforma dentro do razoável.
</p>

<h2 class="section-heading">16. Como falar conosco</h2>
<p class="text-content">
  Dúvidas, solicitações ou reclamações sobre esta Política e o tratamento de
  dados pessoais podem ser direcionadas ao contato pelo e‑mail: adm&#64;mzic.io.
  <br />
  Você também tem o direito de peticionar à ANPD.
</p>

<h2 class="section-heading">Anexo A – Tabela de retenção (referência)</h2>
<p class="text-content">
  Os prazos abaixo são referenciais e podem ser ajustados conforme exigências
  legais/regulatórias específicas, investigações, defesa de direitos ou ordens
  de autoridade. Onde houver conflito, prevalece o prazo legal aplicável.
</p>
<p class="text-content">
  Conta e uso cadastro PF/PJ (PF: nome, e‑mail, telefone, CPF, data de
  nascimento, endereço; Investidor: qualificação, renda, cidadania; Titular PF:
  nome artístico; PJ: razão social/nome fantasia, CNPJ, endereço da sede,
  representante legal), preferências, logs de acesso/uso – enquanto durar a
  relação + até 5 anos após o término (prescrição cível); logs de segurança
  podem ter prazos distintos conforme política interna.
</p>
<p class="text-content">
  Suitability e perfil do investidor (aplicável a Investidores):
  questionários/declarações de adequação, qualificação do investidor, renda
  mensal aproximada, perfil e aceite de termos pertinentes – relação + 5 anos
  (ou prazo superior exigido por obrigação regulatória ou prevenção à fraude);
  registros de aceite mantidos enquanto necessário para prova de conformidade.
</p>
<p class="text-content">
  Cadastro de titulares e catálogos (PF/PJ): nome artístico/alias, nome do
  selo/gravadora, IDs de catálogo, vínculos de obras/fonogramas no Dashboard –
  relação + 5 anos; em disputas, até o encerramento + 5 anos.
</p>
<p class="text-content">
  Identificadores e metadados de conteúdo: ISRC/ISWC/UPC, cue sheets,
  territórios, status de entrega/retirada em DSPs, asset IDs/links – enquanto
  necessários à execução e prestação de contas; cópias locais e reconciliações
  por até 5 anos.
</p>
<p class="text-content">
  Distribuição digital (operações): releases, janelas/territórios, relatórios de
  statements de DSPs, reconciliações e ajustes – enquanto necessárias à execução
  e prestação de contas; em caso de auditoria ou clawback, até o encerramento +
  5 anos.
</p>
<p class="text-content">
  Splits e repartição de royalties: participantes, percentuais, papéis (autor,
  intérprete etc.), regras de priorização (waterfall), históricos de alterações
  e autorizações – enquanto vigente a exploração do conteúdo + 5 anos; em
  disputas, até o encerramento + 5 anos.
</p>
<p class="text-content">
  Editoras – códigos de sociedades: código IPI, código CAE, código ECAD,
  afiliações em PROs/sociedades – enquanto mantida a afiliação/gestão + 5 anos;
  observar regras das PROs/sociedades.
</p>
<p class="text-content">
  Transações e financeiros: ordens, liquidações, repasses de royalties,
  comprovantes, notas fiscais; métodos de pagamento (tokens de pagamento, IDs de
  PSPs), status/chargebacks – relação + 5 anos (fiscal/contábil) e conforme
  obrigações regulatórias aplicáveis; dados mantidos pelo PSP seguem suas
  próprias políticas/prazos.
</p>
<p class="text-content">
  KYC/AML (inclui sensíveis): documento oficial (frente/verso),
  selfie/biometria, validações, endereço completo e demais elementos exigidos
  por lei/regulação e prevenção à fraude – relação + 5 anos (ou superior quando
  exigido por regulação/AML ou investigações); após, eliminação ou anonimização.
</p>
<p class="text-content">
  Logs de segurança e antifraude: fingerprints/identificadores de dispositivo,
  tentativas de login, padrões de uso suspeitos, scores de risco, flags de abuso
  – 6 a 24 meses conforme necessidade técnica/segurança; em caso de incidentes,
  litígios ou ordens legais, até o encerramento + 5 anos.
</p>
<p class="text-content">
  Suporte e comunicações: chamados, e‑mails, mensagens de chat, gravações –
  relação + 2 anos (salvo necessidade de guarda para defesa de direitos).
</p>
<p class="text-content">
  Marketing: preferências, histórico de consentimento/opt‑out, interações com
  campanhas – até revogação do consentimento + 6 meses para registros de prova.
</p>
<p class="text-content">
  Cookies/analytics: identificadores, métricas de navegação/app, telemetria –
  conforme ciclo técnico (em geral até 13 meses) e configurações do Gerenciador
  de Cookies.
</p>
<p class="text-content">
  Dados on‑chain e perfil público: endereços de carteira/conta digital,
  inventário público de ativos, identificadores associados e metadados on‑chain
  – registros on‑chain são permanentes na rede pública; a MZIC mantém
  vinculações internas enquanto durar a relação + 5 anos; após, busca
  desvincular/anonimizar mapeamentos.
</p>
<p class="text-content">
  Dados de terceiros e públicos: informações de PROs/sociedades de gestão,
  agregadoras/distribuidoras, marketplaces parceiros; cadastros/IDs como
  ISRC/ISWC – enquanto necessários para execução e prestação de contas; cópias
  locais e reconciliações por até 5 anos; observados termos das fontes e
  exigências contratuais.
</p>
<p class="text-content">
  Compliance e auditoria: relatórios de monitoramento (AML), evidências de
  controles, auditorias, comunicações a autoridades/reguladores – até 10 anos
  quando exigido por regulação/auditoria; na ausência de exigência específica, 5
  anos.
</p>

<h2 class="section-heading">Anexo B – Categorias de cookies</h2>
<p class="text-content">
  Este anexo descreve, de forma abrangente, as categorias de cookies e
  tecnologias semelhantes que podem ser utilizadas pela plataforma. Nem todas as
  categorias estarão ativas o tempo todo, e algumas dependem do seu
  consentimento.
</p>
<ul class="content-list">
  <li>
    Estritamente necessários/funcionais: Autenticação, manutenção de sessão,
    balanceamento de carga, roteamento, segurança básica (CSRF), registro de
    preferências de privacidade (consent cookie) – Exemplos típicos: session_id,
    csrf_token, cookie de balanceador, cookie de preferência de consentimento –
    Base legal: Execução de contrato / Legítimo interesse – Duração típica:
    Sessão a 12 meses.
  </li>
  <li>
    Segurança e antifraude: Detecção de bots, prevenção de abuso, rate limiting,
    integridade de contas – Exemplos típicos: bot detection, rate‑limit, device
    fingerprint (não rastreante), challenge cookies – Base legal: Legítimo
    interesse / Obrigação legal – Duração típica: 6–24 meses.
  </li>
  <li>
    Preferências: Lembrar idioma, layout, configurações do usuário – Exemplos
    típicos: lang, ui_theme, remember_me – Base legal: Legítimo interesse (ou
    consentimento onde exigido) – Duração típica: 6–12 meses.
  </li>
  <li>
    Analíticos de uso (PostHog): Medir uso e desempenho, entender fluxos,
    melhorar produto (com IP truncado/anonimização quando aplicável) – Exemplos
    típicos: Eventos de navegação, cliques, tempo de página, user-agent – Base
    legal: Consentimento (onde exigido) / Legítimo interesse – Duração típica:
    Até 13 meses.
  </li>
  <li>
    Gravação de sessão / heatmaps (PostHog – opcional): Session replay e mapas
    de calor para diagnóstico de UX; nunca para leitura de campos sensíveis –
    Exemplos típicos: Reproduções de sessão, áreas de clique/rolagem – Base
    legal: Consentimento – Duração típica: Até 13 meses.
  </li>
  <li>
    Experimentos/A-B testing e performance: Testar variações de interface e
    recursos, feature flags – Exemplos típicos: exp_variant, feature_flag_* –
    Base legal: Legítimo interesse (ou consentimento onde exigido) – Duração
    típica: 6–12 meses.
  </li>
  <li>
    Erros e diagnóstico: Monitorar erros, crash reports, estabilidade – Exemplos
    típicos: error_id, trace_id – Base legal: Legítimo interesse – Duração
    típica: 3–12 meses.
  </li>
  <li>
    Publicidade/medição: Personalização, mensuração de campanhas, frequency
    capping. Ativado apenas quando adotado e com consentimento – Exemplos
    típicos: Identificadores de anúncio/medição – Base legal: Consentimento –
    Duração típica: 3–13 meses.
  </li>
  <li>
    Mídias sociais/embeds: Botões de compartilhamento, players e integrações de
    terceiros – Exemplos típicos: Cookies definidos por plataformas de mídia
    social/players – Base legal: Consentimento – Duração típica: 3–13 meses.
  </li>
  <li>
    Gerenciamento de tags e consentimento: Disparar tags de forma controlada e
    respeitar preferências de privacidade – Exemplos típicos: gtm_*,
    consent_mode_* – Base legal: Legítimo interesse – Duração típica: 12–24
    meses.
  </li>
  <li>
    SDKs móveis / notificações: Identificadores técnicos para telemetria e
    notificações push no app – Exemplos típicos: ID de dispositivo/instalação –
    Base legal: Consentimento / Legítimo interesse – Duração típica: Até 24
    meses (ou ciclo do app).
  </li>
</ul>
